const service = require('@/assets/js/request')
class phoneLogin {
  /**
   * 获取验证码
   */
  static getPhoneCode (target, phone, type) {
    service.request({
      method: 'POST',
      url: 'getPhoneCode',
      params: {
        phone, type
      }
    }).then(res => {
      if (res.code === 2001) {
        console.log(res)
      }
    }).catch(err => {
      service.error(err, {
        that: target
      })
    })
  }
  /**
   * 手机验证码登录
   */
  static phoneCodeLogin (target, phone, code) {
    service.request({
      method: 'POST',
      url: 'phoneCodeLogin',
      params: {
        phone, code
      }
    }).then(res => {
      if (res.code === 2001) {
        if (res.data) {
          localStorage.setItem('token', res.data.token)
          target.$message({
            message: res.msg,
            type: 'success'
          })
          setTimeout(() => {
            target.$emit('close')
            target.$store.state.login.isLoginType = true
          }, 1000)
        }
      } else {
        target.$message({
          message: res.msg,
          type: 'warning'
        })
      }
    }).catch(err => {
      service.error(err, {
        that: target
      })
    })
  }
}

export default phoneLogin



// WEBPACK FOOTER //
// ./src/components/login/captcha/captcha.js